import _typeof from "@babel/runtime/helpers/esm/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import CodeMirror from 'codemirror';
import 'codemirror/mode/meta';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ReactCodeMirror = /*#__PURE__*/function (_Component) {
  _inherits(ReactCodeMirror, _Component);

  function ReactCodeMirror(props) {
    var _this;

    _classCallCheck(this, ReactCodeMirror);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactCodeMirror).call(this, props));
    _this.codemirror = null;
    _this.editor = null;
    return _this;
  }

  _createClass(ReactCodeMirror, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderCodeMirror();
    }
  }, {
    key: "renderCodeMirror",
    value: function renderCodeMirror() {
      var _this2 = this; // 生成codemirror实例


      this.editor = CodeMirror.fromTextArea(this.textarea, this.props.options); // 获取CodeMirror用于获取其中的一些常量

      this.codemirror = CodeMirror; // 事件处理映射

      var eventDict = this.getEventHandleFromProps();
      Object.keys(eventDict).forEach(function (event) {
        _this2.editor.on(eventDict[event], _this2.props[event]);
      });
      var _this$props = this.props,
          value = _this$props.value,
          width = _this$props.width,
          height = _this$props.height; // 初始化值

      this.editor.setValue(value || '');

      if (width || height) {
        // 设置尺寸
        this.editor.setSize(width, height);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function () {
      var _componentWillReceiveProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(nextProps) {
        var val, next, options, width, height;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                val = this.editor.getValue();
                next = nextProps.value;

                if (next !== undefined && next !== this.props.value && next !== val) {
                  this.editor.setValue(nextProps.value);
                }

                options = nextProps.options, width = nextProps.width, height = nextProps.height;
                _context.next = 6;
                return this.setOptions(options);

              case 6:
                if (width !== this.props.width || height !== this.props.height) {
                  this.editor.setSize(width, height);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillReceiveProps(_x) {
        return _componentWillReceiveProps.apply(this, arguments);
      }

      return componentWillReceiveProps;
    }() // http://codemirror.net/doc/manual.html#config

  }, {
    key: "setOptions",
    value: function () {
      var _setOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var _this3 = this;

        var mode;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_typeof(options) === 'object')) {
                  _context2.next = 7;
                  break;
                }

                mode = CodeMirror.findModeByName(options.mode);

                if (!(mode && mode.mode)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return import("codemirror/mode/".concat(mode.mode, "/").concat(mode.mode, ".js"));

              case 5:
                if (mode) {
                  options.mode = mode.mime;
                }

                Object.keys(options).forEach(function (name) {
                  if (options[name] && JSON.stringify(options[name])) {
                    _this3.editor.setOption(name, options[name]);
                  }
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setOptions(_x2) {
        return _setOptions.apply(this, arguments);
      }

      return setOptions;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.editor) {
        this.editor.toTextArea();
      }
    } // 将props中所有的事件处理函数映射并保存

  }, {
    key: "getEventHandleFromProps",
    value: function getEventHandleFromProps() {
      var propNames = Object.keys(this.props);
      var eventHandle = propNames.filter(function (prop) {
        return /^on+/.test(prop);
      });
      var eventDict = {};
      eventHandle.forEach(function (ele) {
        eventDict[ele] = ele.slice(2).toLowerCase();
      });
      return eventDict;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return React.createElement("textarea", {
        ref: function ref(instance) {
          _this4.textarea = instance;
        }
      });
    }
  }]);

  return ReactCodeMirror;
}(Component);

export { ReactCodeMirror as default };
ReactCodeMirror.defaultProps = {
  value: '',
  options: {},
  width: '100%',
  height: '100%'
};
ReactCodeMirror.propTypes = {
  value: PropTypes.string,
  options: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};